import React from 'react';
import { Card, Typography, CardContent, Box, Chip } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

const StatCard = ({ card }) => {
    const theme = useTheme();

    const trendColors = {
        up: theme.palette.mode === 'light' ? theme.palette.success.main : theme.palette.success.dark,
        down: theme.palette.mode === 'light' ? theme.palette.error.main : theme.palette.error.dark,
        neutral: theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700],
    };

    // const labelColors = {
    //     up: 'success',
    //     down: 'error',
    //     neutral: 'default',
    // };

    //const color = labelColors[card.trend];
    const chartColor = trendColors[card.trend];
    const trendValues = { up: '+25%', down: '-25%', neutral: '+5%' };
    return (
        <Card variant="outlined" style={{ height: '100%', flexGrow: 1 }}>
            <CardContent>
                <Typography component="h2" variant="subtitle2" gutterBottom>
                    {card.title}
                </Typography>
                <Box display="flex" flexDirection="column" justifyContent="space-between" flexGrow={1}>
                    <Box display="flex" flexDirection="column" justifyContent="space-between" flexGrow={1}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <Typography variant="h4" component="p">
                                {card.value}
                            </Typography>
                            <Chip
                                size="small"
                                label={trendValues[card.trend]}
                                variant="outlined"
                                style={{
                                    borderColor: chartColor,
                                    color: chartColor,
                                }}
                            />
                        </Box>
                        <Typography variant="caption" style={{ color: theme.palette.text.secondary }}>
                            {card.interval}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default StatCard;
